import React, { useRef } from "react";
import styled from "styled-components";

import { AddIcon } from "assets/icons";
import { Label } from "ui/components/styled/formControls";

import { ButtonPrimary, ButtonTertiary } from "../Button";
import { Popover } from "../popover";
import { NoItems } from "./NoItems";
import { WithNewItemLine } from "./WithNewItemLine";
import { AddButton, Form, FormFooter, Header, ItemCount, ItemListInputWrapper } from "./styled";

const AddPopover = styled(Popover)`
  .popover-content {
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
  }
`;

interface ItemListInputProps {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  id: string;
  itemCount?: number;
  label: string;
  required?: boolean;
  submitDisabled: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  renderFormInputs: () => React.ReactNode;
}
export const ItemListInput = (props: ItemListInputProps) => {
  const {
    children,
    className,
    disabled = false,
    id,
    itemCount,
    required,
    submitDisabled,
    label,
    renderFormInputs,
    onCancel,
    onSubmit,
  } = props;
  const openPopupButtonRef = useRef<HTMLButtonElement | null>(null);

  const handleCancel = (closePopup: () => void) => {
    onCancel();
    closePopup();
  };

  const submit = (e: React.FormEvent<HTMLFormElement>, closePopup: () => void) => {
    e.preventDefault();
    onSubmit();
    closePopup();
    openPopupButtonRef.current?.focus();
  };

  return (
    <ItemListInputWrapper className={className}>
      <Header data-testid="ItemListInput_header">
        <Label inputId={id} label={label} required={required} />
        {itemCount !== undefined && <ItemCount>{itemCount}</ItemCount>}
        {!disabled && (
          <AddPopover
            placement="bottom-end"
            renderContent={(close, isOpen) => (
              <Form onSubmit={(e) => submit(e, close)}>
                {renderFormInputs()}
                <FormFooter>
                  <ButtonTertiary
                    type="button"
                    title={"Cancel"}
                    onClick={() => handleCancel(close)}
                  >
                    Cancel
                  </ButtonTertiary>
                  <ButtonPrimary title={"Submit"} disabled={submitDisabled}>
                    Submit
                  </ButtonPrimary>
                </FormFooter>
              </Form>
            )}
            renderTrigger={() => (
              <AddButton type="button" ref={openPopupButtonRef} title={"Add"}>
                <AddIcon aria-hidden={true} />
              </AddButton>
            )}
          />
        )}
      </Header>
      <div id={id}>{children}</div>
    </ItemListInputWrapper>
  );
};

ItemListInput.NoItems = NoItems;
ItemListInput.WithNewItemLine = WithNewItemLine;

export default ItemListInput;
